module.exports = __webpack_public_path__ + "static/media/tabela.35ce5254.jpeg";